import { render } from "./Mv1mv2View.vue?vue&type=template&id=c9ef462c&scoped=true"
import script from "./Mv1mv2View.vue?vue&type=script&lang=js"
export * from "./Mv1mv2View.vue?vue&type=script&lang=js"

import "./Mv1mv2View.vue?vue&type=style&index=0&id=c9ef462c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ef462c"]])

export default __exports__